module.exports = __webpack_public_path__ + "media/base/input_email-74c7f819.svg";